/*
 * OktaVerifyStepTwo Messages
 *
 * This contains all the text for the OktaVerifyStepTwo component.
 *
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.components.OktaVerifyStepTwo";

export default defineMessages(scope, {
  header: "This is the OktaVerifyStepTwo component!",
  codeTextField: "Enter Code",
  backButtonLabel: "Back to QR Code",
  verifyButtonLabel: "Verify",
  cancelButtonLabel: "Cancel",
  invalidCodeErrorMessage: "Incorrect code. Please try again.",
});
